import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_ISSUE_LINK } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDIssueLinkState extends EntityState<IID_ISSUE_LINK, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_ISSUE_LINK })
@InterfaceDataStore(InterfaceName.ISSUE_LINK)
export class IIDIssueLinkStore extends EntityStore<IIDIssueLinkState> {
  constructor() {
    super([]);
  }
}
